import { createElement } from 'react'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Favorite } from './components/favoriteButton'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'athleteDTO.logo',
    Cell: createInWinImage,
  },
  {
    Header: 'Name',
    accessor: 'athleteDTO.name',
  },
  {
    Header: 'Surname',
    accessor: 'athleteDTO.surname',
  },
  {
    Header: 'Nationality',
    accessor: 'athleteDTO.nationality',
    minWidth: 130,
    width: 130,
  },
  {
    Header: 'Sport',
    accessor: 'athleteDTO.sport',
  },
  {
    Header: 'Date Of Birth',
    accessor: 'athleteDTO.dateOfBirth',
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(Favorite, { ...props }),
  },
]
